import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const VerifyMasthead = () => {
  const { t } = useTranslation();

  return (
    <Box
      component="header"
      sx={theme => ({
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        pb: 2,
        mb: 3,
        borderBottom: `3px solid ${theme.palette.primary.main}`,
      })}
    >
      <Box
        aria-hidden="true"
        sx={theme => ({
          width: 34,
          height: 34,
          flex: "0 0 auto",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.main,
        })}
      >
        M
      </Box>
      <Box>
        <Typography
          component="h1"
          sx={theme => ({
            fontSize: "19px",
            fontWeight: 700,
            letterSpacing: "-0.01em",
            color: theme.palette.primary.main,
          })}
        >
          {t("verify.page_title")}
        </Typography>
        <Typography
          sx={theme => ({
            fontSize: "12.5px",
            color: theme.palette.text.secondary,
          })}
        >
          {t("verify.brand")}
        </Typography>
      </Box>
    </Box>
  );
};

export default VerifyMasthead;
